import type * as React from 'react';
const SvgIcoNavTemplates = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" {...props}>
    <path
      d="M7 16h7v2H7zm0-4h10v2H7zm0-4h10v2H7zm12-4h-4.18C14.4 2.84 13.3 2 12 2s-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04a2.01 2.01 0 0 0-1.44 1.19c-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75M19 20H5V6h14z"
      fill="currentColor"
    />
  </svg>
);
export default SvgIcoNavTemplates;
